import React from 'react';
import { classNames } from './classNames';

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(({
  className,
  type = 'text',
  ...props
}, ref) => (
  <input
    ref={ref}
    type={type}
    className={classNames('form-control', className)}
    {...props}
  />
));

TextInput.displayName = 'TextInput';

export default TextInput;

